/* eslint-disable camelcase */
/* eslint-disable no-underscore-dangle */
import React, { useCallback, useContext, useEffect, useState } from "react";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import { loadStripe } from "@stripe/stripe-js";
import {
  CardCvcElement,
  CardExpiryElement,
  CardNumberElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import { format } from "date-fns";
import {
  Scroll,
  CarSimple,
  CreditCard,
  Cardholder,
  // Newspaper,
} from "phosphor-react";
import PropTypes from "prop-types";
import TransactionWrapper from "components/templates/TransactionWrapper";
import Button from "components/Button";
import CheckBox from "components/CheckBox";
import termsAndCondition from "assets/images/datafarming-rapidem-terms-and-condition.pdf";
import InputField from "components/Input";
import AddressFields from "components/AddressFields";
import { UserContext } from "context/user";
import {
  createContactDetails,
  getContactDetails,
  updateContactDetails,
} from "api/User";
import "./index.scss";
import {
  createBookingPayment,
  getEmBookingPrice,
  getMachinesInfo,
  requestBooking,
} from "api/Booking";
import { getDatesInRange, getMachinePrice, getUserTwitterDomain } from "utils";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { SUCCESS_STATUS } from "constants/success-status";
import PanelWrapper from "components/elements/Panel";
import Divider from "components/elements/Divider";
import ProcessingFeeModal from "components/Modal/ProcessingFeeModal";

const cardNumberElementOptions = {
  showIcon: true,
  style: {
    base: {
      fontSize: "16px",
      backgroundColor: "#fff",
      color: "#292b33",
      "::placeholder": {
        color: "#8a8e99",
        fontWeight: "300",
      },
    },
  },
  placeholder: "---- ---- ---- ----",
};

const cardElementOptions = {
  style: {
    base: {
      fontSize: "16px",
      backgroundColor: "#fff",
      color: "#292b33",
      "::placeholder": {
        color: "#8a8e99",
        fontWeight: "300",
      },
    },
  },
};

const STRIPE_PK = process.env.REACT_APP_STRIPE_PUBLISHER_KEY;

const EMPaymentForm = ({ step, handleNext }) => {
  const history = useHistory();
  const { token, user } = useContext(UserContext);

  const [selectedMachine, setSelectedMachine] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [bookingDays, setBookingDays] = useState(0);
  const [isTermsAndConditionChecked, setTermsAndConditionChecked] =
    useState(false);

  const [isSameBillingAndShipping, setIsSameBillingAndShipping] =
    useState(false);

  const stripe = useStripe();
  const elements = useElements();

  const [userDetails, setUserDetails] = useState(null);
  const [formType, setFormType] = useState("");

  const [isProcessing, setIsProcessing] = useState(false);
  const [paymentType, setPaymentType] = useState("card");

  const [machinesList, setMachinesList] = useState(null);
  const [bookingPrice, setBookingPrice] = useState(null);
  const [reservationDetails, setReservationDetails] = useState(null);
  const [reservationError, setReservationError] = useState(null);
  const [cardErrorMessage, setCardErrorMessage] = useState({
    name: "",
    cardNumber: "",
    cardExpiry: "",
    cardCvc: "",
  });

  const [reservedDates, setReservedDates] = useState([]);

  const [billingDetails, setBillingDetails] = useState({
    name: "",
    companyName: "",
    address1: "",
    address2: "",
    city: "",
    zipCode: "",
    country: "",
    state: "",
    phoneNumber: "",
    email: "",
  });

  const [billingDetailsError, setBillingDetailsError] = useState({
    companyName: "",
    address1: "",
    country: "",
    state: "",
    city: "",
    zipCode: "",
  });

  const [shippingDetails, setShippingDetails] = useState({
    name: "",
    companyName: "",
    address1: "",
    address2: "",
    city: "",
    zipCode: "",
    country: "",
    state: "",
    email: "",
  });
  const [shippingDetailsError, setShippingDetailsError] = useState({
    name: "",
    address1: "",
    city: "",
    zipCode: "",
    country: "",
    state: "",
  });

  const [range, setRange] = useState(null);
  const [emailDomain, setEmailDomain] = useState("");
  const [hideCvc, setHideCvc] = useState(false);
  const [isOpenFeeModal, setIsOpenFeeModal] = useState(false);
  const isErrorListHasValue = (errorList) => {
    const isListHasError = Object.values(errorList).some(
      (error) => error !== null && error !== "" && typeof error !== "undefined"
    );
    return isListHasError;
  };

  const validateField = (fieldName, value) => {
    let error;
    if (fieldName === "name") {
      error = value ? "" : "Enter cardholder name";
    } else if (fieldName === "address1") {
      error = value ? "" : "Enter address";
    } else if (fieldName === "city") {
      error = value ? "" : "Enter city";
    } else if (fieldName === "country") {
      error = value ? "" : "Please select country";
    } else if (fieldName === "state") {
      error = value ? "" : "Please select state/province.";
    } else if (fieldName === "zipCode") {
      error = value ? "" : "Please enter zip or postal code.";
    }
    return error;
  };

  const handleSelectCountry = (val) => {
    const newField = { ...billingDetails, country: val };
    setBillingDetails(newField);
    const fieldError = validateField("country", val);
    const newError = {
      ...billingDetailsError,
      country: fieldError || "",
    };
    setBillingDetailsError(newError);
  };

  const handleShippingSelectCountry = (val) => {
    const newField = { ...shippingDetails, country: val };
    setShippingDetails(newField);
    const fieldError = validateField("country", val);
    const newError = {
      ...shippingDetailsError,
      country: fieldError || "",
    };
    setShippingDetailsError(newError);
  };

  const validateInput = (e) => {
    e.preventDefault();
    const { value, name } = e.target;
    const fieldError = validateField(name, value);

    if (name === "name") {
      const newError = {
        ...cardErrorMessage,
        [name]: fieldError || "",
      };
      setCardErrorMessage(newError);
      return;
    }
    const newError = {
      ...billingDetailsError,
      [name]: fieldError || "",
    };
    setBillingDetailsError(newError);
  };

  const validateShippingInput = (e) => {
    e.preventDefault();
    const { value, name } = e.target;
    const fieldError = validateField(name, value);

    if (name === "name") {
      const newError = {
        ...cardErrorMessage,
        [name]: fieldError || "",
      };
      setCardErrorMessage(newError);
      return;
    }
    const newError = {
      ...shippingDetailsError,
      [name]: fieldError || "",
    };
    setShippingDetailsError(newError);
  };

  const handleInputChange = (event) => {
    event.preventDefault();
    validateInput(event);
    const { value, name } = event.target;
    const newField = { ...billingDetails, [name]: value };
    setBillingDetails(newField);
  };

  const handleShippingInputChange = (event) => {
    event.preventDefault();
    validateShippingInput(event);
    const { value, name } = event.target;
    const newField = { ...shippingDetails, [name]: value };
    setShippingDetails(newField);
  };

  const validateCardOnchange = (e) => {
    const newError = {
      ...cardErrorMessage,
      [e?.elementType]: e?.error?.message || "",
    };
    setCardErrorMessage(newError);
  };

  const [pk, setPk] = useState();
  const [stripePromise, setStripePromise] = useState(null);
  useEffect(() => {
    setTimeout(() => {
      setPk(STRIPE_PK);
    }, 1500);
  }, []);

  useEffect(() => {
    if (pk && !stripePromise) {
      setStripePromise(loadStripe(pk));
    }
  }, [pk, stripePromise]);

  const formatStartDate = startDate
    ? format(new Date(startDate), "dd MMM yyyy")
    : "";
  const formatEndDate = endDate ? format(new Date(endDate), "dd MMM yyyy") : "";

  const computeBookingDays = useCallback((start, end) => {
    const beginDay = new Date(start);
    const lastDay = new Date(end);
    const timeDiff = lastDay.getTime() - beginDay.getTime();
    const numOfDays = timeDiff / (1000 * 3600 * 24) + 1;
    return numOfDays;
  }, []);

  useEffect(() => {
    if (startDate && endDate) {
      const numOfDays = computeBookingDays(startDate, endDate);
      if (numOfDays < 3) {
        setReservationError(
          "Please select atleast 3 days for booking a machine."
        );
        setBookingDays(0);
      } else {
        setBookingDays(numOfDays);
      }
    }
  }, [startDate, endDate, computeBookingDays]);

  const fetchUserDetails = useCallback(async () => {
    if (!token) return;
    const userDetailsData = await getContactDetails(token);
    setUserDetails(userDetailsData.data);
    if (userDetailsData.data.email) {
      const userDomain = getUserTwitterDomain(userDetailsData.data.email);
      setEmailDomain(userDomain);
    }
  }, [token]);

  const fetchMachineList = useCallback(async () => {
    if (!token) return;
    const machinesData = await getMachinesInfo(token);
    setMachinesList(machinesData);
  }, [token]);

  const fetchPriceDetails = useCallback(async () => {
    if (!token) return;
    const bookingPriceData = await getEmBookingPrice(token);
    setBookingPrice(bookingPriceData);
  }, [token]);

  useEffect(() => {
    if (userDetails) {
      if (emailDomain !== "twitter.df") {
        setBillingDetails({
          name: userDetails?.first_name || "",
          companyName: "",
          address1: userDetails?.address1 || "",
          address2: userDetails?.address2 || "",
          city: userDetails?.city || "",
          zipCode: userDetails?.post_code || "",
          country: userDetails?.country || "",
          state: userDetails?.state || "",
          first_name: userDetails?.first_name || "",
          last_name: userDetails?.last_name || "",
          phoneNumber: userDetails?.phone_number,
          email: userDetails?.email || user?.email,
        });
        setShippingDetails({
          name: userDetails?.first_name || "",
          companyName: "",
          address1: userDetails?.address1 || "",
          address2: userDetails?.address2 || "",
          city: userDetails?.city || "",
          zipCode: userDetails?.post_code || "",
          country: "au",
          state: userDetails?.state || "",
          first_name: userDetails?.first_name || "",
          last_name: userDetails?.last_name || "",
          phoneNumber: userDetails?.phone_number,
          email: userDetails?.email || user?.email,
        });
        setFormType("update");
      } else {
        setBillingDetails({
          name: userDetails?.first_name || "",
          companyName: "",
          address1: userDetails?.address1 || "",
          address2: userDetails?.address2 || "",
          city: userDetails?.city || "",
          zipCode: userDetails?.post_code || "",
          country: userDetails?.country || "",
          state: userDetails?.state || "",
          first_name: userDetails?.first_name || "",
          last_name: userDetails?.last_name || "",
          phoneNumber: userDetails?.phone_number,
          email: "",
        });
        setShippingDetails({
          name: userDetails?.first_name || "",
          companyName: "",
          address1: userDetails?.address1 || "",
          address2: userDetails?.address2 || "",
          city: userDetails?.city || "",
          zipCode: userDetails?.post_code || "",
          country: "au",
          state: userDetails?.state || "",
          first_name: userDetails?.first_name || "",
          last_name: userDetails?.last_name || "",
          phoneNumber: userDetails?.phone_number,
          email: "",
        });
        setFormType("update");
      }
    } else {
      setFormType("add");
    }
  }, [userDetails, user, emailDomain]);

  useEffect(() => {
    fetchMachineList();
    fetchPriceDetails();
    fetchUserDetails();
  }, [fetchMachineList, fetchPriceDetails, fetchUserDetails]);

  const handleCheckReservation = useCallback(
    async (start, end) => {
      if (start && end) {
        const startDateFormatted = format(new Date(start), "MMMM d, yyyy");
        const endDateFormatted = format(new Date(end), "MMMM d, yyyy");
        const startDateTimeStamp = Date.UTC(
          start.getFullYear(),
          start.getMonth(),
          start.getDate(),
          0,
          0,
          0,
          0
        );

        const endDateTimeStamp = Date.UTC(
          end.getFullYear(),
          end.getMonth(),
          end.getDate(),
          0,
          0,
          0,
          0
        );

        let isReserved = "";
        if (reservedDates) {
          isReserved = reservedDates?.find((reservation) => {
            const reservedDate = format(new Date(reservation), "MMMM d, yyyy");
            if (
              reservedDate === startDateFormatted ||
              reservedDate === endDateFormatted
            ) {
              return reservation;
            }
            return null;
          });
        }

        if (!isReserved) {
          setReservationError(null);
          const payload = {
            machine_id: selectedMachine,
            start_date: startDateTimeStamp,
            end_date: endDateTimeStamp,
          };
          const response = await requestBooking(payload, token).catch(
            (error) => {
              if (error?.response?.data) {
                setReservationError(
                  "Your desired dates has been booked by another customer. Try selecting a different one."
                );
                fetchMachineList();
              }
            }
          );
          if (response) {
            setReservationDetails(response);
            setReservationError(null);
            handleNext(2);
          }
        }
      }
    },
    [token, selectedMachine, reservedDates, handleNext, fetchMachineList]
  );

  const handleClearDates = () => {
    setStartDate(null);
    setEndDate(null);
    setBookingDays(0);
    setReservationDetails(null);
    setReservationError(null);
    setRange(null);
    fetchMachineList();
  };

  const validateOnSubmit = (objectList) => {
    const errorList = {};
    Object.keys(objectList).forEach((key) => {
      if (key !== "name") {
        errorList[key] = validateField(key, objectList[key]);
      }
    });
    setBillingDetailsError(errorList);
    return errorList;
  };

  const validateShippingOnSubmit = (objectList) => {
    const errorList = {};
    Object.keys(objectList).forEach((key) => {
      if (key !== "name") {
        errorList[key] = validateField(key, objectList[key]);
      }
    });
    setShippingDetailsError(errorList);
    return errorList;
  };

  const validateStripeElement = () => {
    // get reference to the card object
    const cardNumberElement = elements?.getElement(CardNumberElement);
    const cardExpiryElement = elements?.getElement(CardExpiryElement);
    const cardCvcElement = elements?.getElement(CardCvcElement);

    const newCardError = {
      ...cardErrorMessage,
    };

    // validate card holder name
    if (billingDetails?.name === "") {
      newCardError.name = "Please input card holder name.";
    }
    // validate card number
    if (cardNumberElement?._empty) {
      newCardError.cardNumber = "Please input your card details.";
    } else if (
      cardNumberElement?._complete === false ||
      cardNumberElement?._invalid
    ) {
      newCardError.cardNumber = "Please enter a valid card number";
    }
    // validate card expiry
    if (cardExpiryElement?._empty) {
      newCardError.cardExpiry = "Please input your card expiry details.";
    } else if (
      cardExpiryElement?._complete === false ||
      cardExpiryElement?._invalid
    ) {
      newCardError.cardExpiry = "Card expiry is invalid.";
    }

    // validate card cvc
    if (cardCvcElement?._empty) {
      newCardError.cardCvc = "Please input your card's CVV/CVC.";
    } else if (
      cardCvcElement?._complete === false ||
      cardCvcElement?._invalid
    ) {
      newCardError.cardCvc =
        "Please copy your CVV/CVC code from the back of your card and continue with your payment.";
    }
    setCardErrorMessage(newCardError);
    return newCardError;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!stripe || !elements) {
      // Stripe.js has not loaded yet. Make sure to disable
      // form submission until Stripe.js has loaded.
      return;
    }
    const cardNumberElement = elements?.getElement(CardNumberElement);
    const billingDetailsErrorList = validateOnSubmit(billingDetails);
    const shippingDetailsErrorList = validateShippingOnSubmit(shippingDetails);
    const cardDetailsErrorList = validateStripeElement();

    if (
      isErrorListHasValue(billingDetailsErrorList) ||
      isErrorListHasValue(cardDetailsErrorList) ||
      isErrorListHasValue(shippingDetailsErrorList)
    ) {
      toast.error("There's some validation error");
      return;
    }

    setIsProcessing(true);

    const params = {
      data: {
        first_name: billingDetails?.first_name || "",
        last_name: billingDetails?.last_name || "",
        email:
          emailDomain === "twitter.df"
            ? billingDetails?.email
            : userDetails?.email || user?.email,
        address1: billingDetails?.address1,
        address2: billingDetails?.address2,
        city: billingDetails?.city,
        state: billingDetails?.state,
        country: billingDetails?.country,
        post_code: billingDetails?.zipCode,
        phone_number: billingDetails?.phoneNumber || "",
        user_type: userDetails?.user_type || "other",
      },
    };

    let response = {};
    if (formType === "add") {
      response = await createContactDetails(params, token);
    } else {
      response = await updateContactDetails(params, token);
    }

    if (SUCCESS_STATUS.includes(response.status)) {
      const payload = {
        reservation_id: reservationDetails?.reservation_id,
        first_name: userDetails?.first_name,
        last_name: userDetails?.last_name,
        company_name: shippingDetails?.companyName,
        address1: shippingDetails?.address1,
        address2: shippingDetails?.address2,
        city: shippingDetails?.city,
        state: shippingDetails?.state,
        country: shippingDetails?.country,
        post_code: shippingDetails?.zipCode,
      };
      const { client_secret: clientSecret } = await createBookingPayment(
        payload,
        token
      );
      // proceed to payment
      const paymentMethodRequest = await stripe.createPaymentMethod({
        type: "card",
        card: cardNumberElement,
        billing_details: {
          address: {
            city: billingDetails?.state,
            country: billingDetails?.country,
            line1: billingDetails?.streetAddress,
            line2: billingDetails?.suburb,
            postal_code: billingDetails?.zipCode,
          },
          name: billingDetails?.companyName,
        },
      });
      // check for payment status
      const confirmedCardPayment = await stripe.confirmCardPayment(
        clientSecret,
        {
          payment_method: paymentMethodRequest?.paymentMethod?.id,
        }
      );

      if (confirmedCardPayment?.paymentIntent?.status === "succeeded") {
        history.push("/rapid-em-booking/success");
      } else if (confirmedCardPayment?.error) {
        toast.error(confirmedCardPayment?.error?.message);
        setIsProcessing(false);
      }
    }
  };

  useEffect(() => {
    if (!selectedMachine) return;
    const selected = machinesList?.find(
      (machine) => machine.machine_id === selectedMachine
    );
    const blockedDates = [];
    if (selected?.reserved_dates?.length) {
      selected?.reserved_dates?.forEach((rsvDate) => {
        blockedDates.push(
          ...getDatesInRange(rsvDate?.start_date, rsvDate?.end_date)
        );
      });
    }
    if (blockedDates?.length) {
      setReservedDates(
        blockedDates.map((blockedDate) => new Date(blockedDate))
      );
    }
  }, [selectedMachine, machinesList]);
  const canProceedToReview = () => {
    return startDate && endDate;
  };

  const goTo = () => {
    if (step === 1 && canProceedToReview()) {
      handleCheckReservation(startDate, endDate);
    } else if (step === 2) {
      handleNext(3);
    }
  };

  const goBack = () => {
    if (step === 2) {
      handleNext(1);
      fetchMachineList();
    } else if (step === 3) {
      handleNext(2);
    }
  };

  const { minimumFee, taxRate, totalPrice } = getMachinePrice(bookingPrice);

  const handleBooking = (e) => {
    const { from, to } = e;
    setStartDate(from);
    setEndDate(to);
    setReservationError(null);
    setRange(e);
    if (from && to) {
      const formatStart = format(new Date(from), "dd MMM yyyy");
      const formatEnd = format(new Date(to), "dd MMM yyyy");
      const numberOfDays = computeBookingDays(from, to);
      if (formatStart === formatEnd) {
        setStartDate(null);
        setEndDate(null);
      } else if (numberOfDays < 3) {
        setReservationError(
          "Please select atleast 3 days for booking a machine."
        );
      }
    }
  };

  const handleSelectMachine = (e) => {
    setSelectedMachine(e);
    setRange(null);
    setReservationDetails(null);
    setReservationError(null);
    setStartDate(null);
    setEndDate(null);
  };
  return (
    <>
      {step === 1 && (
        <TransactionWrapper
          icon={<CarSimple size={32} color="#339DFF" />}
          title="Select and book your machine"
        >
          <PanelWrapper label="Select machine to view available dates">
            <div className="select-wrapper">
              <div className="group-label">
                <p className="label"> Rapid-EM™ Machines</p>
              </div>

              <div className="select">
                <select
                  name="machine"
                  className="select-input"
                  onChange={(e) => handleSelectMachine(e.target.value)}
                  value={selectedMachine}
                >
                  <option value="">Select your EM machine</option>
                  {machinesList?.map((machine) => {
                    return (
                      <option value={machine?.machine_id}>
                        {machine?.machine_id}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>

            {selectedMachine && (
              <>
                <div className="calendar-picker">
                  <div className="group-label">
                    <p className="label"> Available dates to book</p>
                  </div>
                  <DayPicker
                    numberOfMonths={2}
                    mode="range"
                    selected={range}
                    onSelect={(e) => handleBooking(e)}
                    modifiersClassNames={{
                      selected: "my-selected",
                      today: "my-today",
                      range_middle: "my-range-middle",
                    }}
                    fromDate={new Date()}
                    disabled={reservedDates}
                    defaultMonth={range ? range?.from : new Date()}
                  />
                  {reservationError && (
                    <>
                      <div className="reservation-error">
                        <p className="error">{reservationError}</p>
                      </div>
                    </>
                  )}
                  <Button
                    label="Clear Date"
                    color="white"
                    type="outlined"
                    rounded
                    onClick={() => handleClearDates()}
                  />
                </div>

                <div className="selected-dates">
                  <div className="date-item">
                    <label className="label">Start Date</label>
                    <p className={`value ${formatStartDate || "-placeholder"}`}>
                      {formatStartDate || "No date selected"}
                    </p>
                  </div>
                  <div className="date-item">
                    <label className="label">End Date</label>
                    <p className={`value ${formatEndDate || "-placeholder"}`}>
                      {formatEndDate || "No date selected"}
                    </p>
                  </div>
                </div>
              </>
            )}
          </PanelWrapper>
          {step !== 3 && (
            <div className="page-action">
              {[2, 3].includes(step) && (
                <Button
                  prepend
                  icon="arrow-left"
                  label="Previous"
                  color="white"
                  type="outlined"
                  onClick={() => goBack()}
                />
              )}
              <Button
                type="solid"
                label="Next"
                onClick={() => goTo()}
                color="blue"
                rounded
                disabled={bookingDays === 0}
                block
              />
            </div>
          )}
        </TransactionWrapper>
      )}
      {step === 2 && (
        <TransactionWrapper
          icon={<Scroll size={32} color="#339DFF" />}
          title="Review booking details"
        >
          <PanelWrapper>
            <div className="booking-days">
              <h3 className="title">To be rented for {bookingDays} days</h3>
              {startDate && endDate && (
                <p className="description">
                  from {formatStartDate} to {formatEndDate}
                </p>
              )}
            </div>
            <div className="notes">
              <p className="title">Notes before booking</p>
              <p className="description">
                The processing fee is not included in this checkout.
              </p>
              <p className="subs">
                For more information on hiring costs, please check the example{" "}
                <button
                  type="button"
                  className="link"
                  onClick={() => setIsOpenFeeModal(true)}
                  aria-hidden
                >
                  here.
                </button>
              </p>
            </div>
            <ul className="cost-list">
              <li className="cost-item">
                <p className="name">Minimum Upfront Hire Fee</p>
                <p className="cost">
                  AU{" "}
                  {minimumFee?.toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                  })}
                </p>
              </li>
              {/* <li className="cost-item">
                <p className="name">Freight Fee</p>
                <p className="cost">
                  AU{" "}
                  {freightFee?.toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                  })}
                </p>
              </li> */}
              {userDetails?.country?.toUpperCase() === "AU" && (
                <li className="cost-item">
                  <p className="name">GST</p>
                  <p className="cost">
                    {/* gst fee from backend */}
                    AU{" "}
                    {taxRate?.toLocaleString("en-US", {
                      style: "currency",
                      currency: "USD",
                    })}
                  </p>
                </li>
              )}

              <li className="cost-item">
                <p className="name">Total Price</p>
                <p className="cost">
                  {/* Total including gst */}
                  AU{" "}
                  {totalPrice?.toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                  })}
                </p>
              </li>
            </ul>
            <Divider />
            <div className="list-container">
              <p className="title">Things to remember</p>
              <ul className="remember-list">
                <li className="remember-item">
                  Processed data will only be applied to the current fields on
                  your farm.
                </li>
                <li className="remember-item">
                  The Rapid-EM™ service charges $4/ha + freight fee. However,
                  there is a minimum fee that has to be paid upfront with the
                  freight fee. This upfront payment will be deducted from your
                  final invoice amount. Upfront payments are to be made via
                  credit card.
                </li>
                <li className="remember-item">
                  Shipping times may vary, and may cause delays in the arrival
                  of the machine.
                </li>
                <li className="remember-item">
                  Late fee will be charged when a customer fails to return the
                  machine on the supposed end date.
                </li>
              </ul>
            </div>
            <div className="terms-condition">
              <p className="note">
                Before proceeding to payment, you should read and accept our
                booking{" "}
                <a
                  className="link"
                  href={termsAndCondition}
                  target="_blank"
                  rel="noreferrer"
                >
                  terms and conditions
                </a>
                .
              </p>
              <CheckBox
                checked={isTermsAndConditionChecked}
                onChange={() =>
                  setTermsAndConditionChecked((prevState) => !prevState)
                }
                label="I have read and agree to terms and conditons."
              />
            </div>
            <ProcessingFeeModal
              isOpen={isOpenFeeModal}
              onClose={() => setIsOpenFeeModal(false)}
              deductibles={minimumFee}
            />
          </PanelWrapper>
          {step !== 3 && (
            <div className="page-action">
              {[2, 3].includes(step) && (
                <Button
                  prepend
                  label="Go back"
                  color="white"
                  rounded
                  type="solid"
                  onClick={() => goBack()}
                />
              )}
              <Button
                type="solid"
                label="Proceed to payment"
                onClick={() => goTo()}
                color="blue"
                rounded
                disabled={!isTermsAndConditionChecked}
                block
              />
            </div>
          )}
        </TransactionWrapper>
      )}
      {step === 3 && (
        <TransactionWrapper
          icon={<Cardholder size={32} color="#339DFF" />}
          title="Payment details"
          description="By providing the correct details, we are able to reach you if we have concerns and updates in regards to your booking."
        >
          <form className="payment-wrapper" onSubmit={handleSubmit}>
            <PanelWrapper label="Payment breakdown" color="black">
              <ul className="cost-list">
                <li className="cost-item -inverted">
                  <p className="name">Minimum Upfront Hire Fee</p>
                  <p className="cost">
                    AU{" "}
                    {minimumFee?.toLocaleString("en-US", {
                      style: "currency",
                      currency: "USD",
                    })}
                  </p>
                </li>
                {/* <li className="cost-item -inverted">
                  <p className="name">Freight Fee</p>
                  <p className="cost">
                    AU{" "}
                    {taxRate?.toLocaleString("en-US", {
                      style: "currency",
                      currency: "USD",
                    })}
                  </p>
                </li> */}
                {userDetails?.country?.toUpperCase() === "AU" && (
                  <li className="cost-item -inverted">
                    <p className="name">GST</p>
                    <p className="cost">
                      {/* gst fee from backend */}
                      AU{" "}
                      {taxRate?.toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                      })}
                    </p>
                  </li>
                )}

                <li className="cost-item -inverted">
                  <p className="name">Total Price</p>
                  <p className="cost">
                    {/* Total including gst */}
                    AU{" "}
                    {totalPrice?.toLocaleString("en-US", {
                      style: "currency",
                      currency: "USD",
                    })}
                  </p>
                </li>
              </ul>
            </PanelWrapper>
            <PanelWrapper label="Contact Details">
              <div className="form-group">
                <InputField
                  id="phoneNumber"
                  placeholder=""
                  label="Contact Number"
                  value={billingDetails?.phoneNumber}
                  onChange={(e) => handleInputChange(e)}
                  onBlur={(e) => validateInput(e)}
                  error={billingDetailsError?.phoneNumber}
                />
                <InputField
                  id="email"
                  placeholder=""
                  label="Email Address"
                  value={billingDetails?.email}
                  onChange={(e) => handleInputChange(e)}
                  onBlur={(e) => validateInput(e)}
                  error={billingDetailsError?.email}
                />
              </div>
            </PanelWrapper>
            <section className="payment-type">
              <div
                className={`payment-item ${
                  paymentType === "card" && "-active"
                }`}
                onClick={() => setPaymentType("card")}
                aria-hidden
              >
                <CreditCard
                  size={32}
                  color={paymentType === "card" ? "#ffffff" : "#8A8E99"}
                />
                <p className="label">Debit or Credit Card</p>
              </div>
              {/* <div
                className={`payment-item ${
                  paymentType === "invoice" && "-active"
                }`}
                onClick={() => setPaymentType("invoice")}
                aria-hidden
              >
                <Newspaper
                  size={32}
                  color={paymentType === "invoice" ? "#ffffff" : "#8A8E99"}
                />
                <p className="label">Invoice</p>
              </div> */}
            </section>
            <PanelWrapper label="Card details">
              <div className="form-group">
                <InputField
                  id="name"
                  placeholder="Cardholder Name"
                  label="Cardholder Name"
                  value={billingDetails?.name}
                  onChange={(e) => handleInputChange(e)}
                  onBlur={(e) => validateInput(e)}
                  error={cardErrorMessage?.name}
                />

                <div className="input-field">
                  {cardErrorMessage?.cardNumber && (
                    <p className="label -error">
                      {cardErrorMessage?.cardNumber}
                    </p>
                  )}
                  <div
                    className={`custom-field ${
                      cardErrorMessage?.cardNumber ? "-error" : ""
                    }`}
                  >
                    <CardNumberElement
                      id="cardNumber"
                      options={cardNumberElementOptions}
                      onChange={validateCardOnchange}
                    />
                  </div>
                  <label htmlFor="cardNumber" className="label">
                    Card Number
                  </label>
                </div>
              </div>
              <div className="form-group -four-column">
                <div className="input-field">
                  {cardErrorMessage?.cardExpiry && (
                    <label className="label -error">
                      {cardErrorMessage?.cardExpiry}
                    </label>
                  )}
                  <div
                    className={`custom-field ${
                      cardErrorMessage?.cardExpiry ? "-error" : ""
                    }`}
                  >
                    <CardExpiryElement
                      id="cardExpiry"
                      options={cardElementOptions}
                      onChange={validateCardOnchange}
                    />
                  </div>
                  <label htmlFor="cardExpiry" className="label">
                    Card Expiry
                  </label>
                </div>
                <div className="input-field">
                  {cardErrorMessage?.cardCvc && (
                    <label className="label -error">
                      {cardErrorMessage?.cardCvc}
                    </label>
                  )}
                  <div
                    className={`custom-field ${
                      cardErrorMessage?.cardCvc ? "-error" : ""
                    } ${hideCvc ? "no-placeholder" : ""}`}
                    id="cvc"
                  >
                    <CardCvcElement
                      id="cardCvc"
                      options={cardElementOptions}
                      onChange={validateCardOnchange}
                      placeholder=""
                      maxLength={5}
                    />
                    <span
                      className={hideCvc ? "icon-eye-close" : "icon-eye"}
                      onClick={() => setHideCvc(!hideCvc)}
                      aria-hidden
                    />
                  </div>
                  <label htmlFor="cardCvc" className="label">
                    CVC/CVV
                  </label>
                </div>
              </div>
            </PanelWrapper>
            <PanelWrapper label="Shipping details">
              <AddressFields
                user={shippingDetails}
                country={shippingDetails?.country}
                states={shippingDetails?.state}
                handleSelectCountry={handleShippingSelectCountry}
                isDisabled={false}
                isDisabledCountry
                handleInputChange={handleShippingInputChange}
                errors={shippingDetailsError}
              />
              <CheckBox
                checked={isSameBillingAndShipping}
                onChange={() =>
                  setIsSameBillingAndShipping((prevState) => !prevState)
                }
                label="My billing details are same with my shipping details"
              />
            </PanelWrapper>
            {!isSameBillingAndShipping && (
              <PanelWrapper label="Billing details">
                <>
                  <InputField
                    id="companyName"
                    placeholder="Ex. Acme"
                    label="Company Name"
                    value={billingDetails?.companyName}
                    onChange={(e) => handleInputChange(e)}
                    onBlur={(e) => validateInput(e)}
                    error={billingDetailsError?.companyName}
                  />
                  <AddressFields
                    user={billingDetails}
                    country={billingDetails?.country}
                    states={billingDetails?.state}
                    handleSelectCountry={handleSelectCountry}
                    isDisabled={false}
                    handleInputChange={handleInputChange}
                    errors={billingDetailsError}
                  />
                </>
              </PanelWrapper>
            )}
            <div className="page-action">
              {[2, 3].includes(step) && (
                <Button
                  prepend
                  label="Go back"
                  color="white"
                  rounded
                  type="solid"
                  onClick={() => goBack()}
                />
              )}
              <Button
                submit
                label={`Pay ${totalPrice?.toLocaleString("en-US", {
                  style: "currency",
                  currency: "USD",
                })}`}
                type="solid"
                rounded
                size="medium"
                block
                color="green"
                disabled={
                  !isTermsAndConditionChecked || !stripe || isProcessing
                }
              />
            </div>
          </form>
        </TransactionWrapper>
      )}
    </>
  );
};

EMPaymentForm.propTypes = {
  step: PropTypes.number,
  handleNext: PropTypes.func,
};

EMPaymentForm.defaultProps = {
  step: 1,
  handleNext: () => {},
};

export default EMPaymentForm;
